import {FeatureTrackingLabels} from "../types";

export class TopicpromoCinemaSlide {

    readonly slideDom: Element;
    readonly featureTrackingLabels: FeatureTrackingLabels;
    readonly position: number;
    readonly comboType: string | null;

    constructor(slideDom: Element) {
        this.slideDom = slideDom;
        this.position = parseInt(slideDom.getAttribute("data-index")!) + 1;
        this.featureTrackingLabels = JSON.parse(slideDom.getAttribute('data-feature-tracking-tile-labels')!);
        this.comboType = slideDom.getAttribute('data-combo-type');
    }

    setIsTrackedAsVisible() {
        this.slideDom.setAttribute("data-is-tracked-visible", String(true));
    }

    isTrackedAsVisible() {
        return this.slideDom.getAttribute("data-is-tracked-visible") === "true";
    }

    registerClickEventHandler(eventHandler: (e: Event) => void) {
        this.slideDom.addEventListener("click", eventHandler);
    }
}